import { render, staticRenderFns } from "./GroupsList.vue?vue&type=template&id=1359952c&scoped=true"
import script from "./GroupsList.ts?vue&type=script&lang=ts&external"
export * from "./GroupsList.ts?vue&type=script&lang=ts&external"
import style0 from "./GroupsList.vue?vue&type=style&index=0&id=1359952c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1359952c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1359952c')) {
      api.createRecord('1359952c', component.options)
    } else {
      api.reload('1359952c', component.options)
    }
    module.hot.accept("./GroupsList.vue?vue&type=template&id=1359952c&scoped=true", function () {
      api.rerender('1359952c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Auth/components/GroupsList/GroupsList.vue"
export default component.exports